// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20q3q","top":"styles_top__37hC8"};